import * as React from 'react';
import {createContext, useContext, ReactNode, FC} from 'react';
import {ElementMap} from './types';
import {isObject} from 'lodash';

const ElementMapContext = createContext<ElementMap>({});

export function useElementMap() {
  return useContext<ElementMap>(ElementMapContext);
}

interface ElementMapProviderProps {
  elementMap?: ElementMap,
  children?: ReactNode,
}

const ElementMapProvider: FC<ElementMapProviderProps> = ({ children, elementMap }) => (
  <ElementMapContext.Provider value={elementMap}>
    {children}
  </ElementMapContext.Provider>
);

const MemoizedElementMapProvider = React.memo(
  ElementMapProvider,
  (prevProps, nextProps) =>
    isObject(prevProps.elementMap) === isObject(nextProps.elementMap)
    && prevProps.children === nextProps.children
);

export default MemoizedElementMapProvider;
